<template>
    <div class="shadow-md p-3">
      Importar Pedidos <br>
      <button class="btn btn-sm btn-success" @click="downloadExcel" :disabled="cargando">Descargar ejemplo</button>
      <div v-if="!importedData">
        <!-- File Input -->
        <input id="fileInput" type="file" class="mt-1 mb-1 p-2 border border-gray-300 rounded-md" @change="handleFileChange" 
        ref="fileInputRef" />
        <!-- accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" -->

        <!-- File Drop Square -->
        <div class="flex justify-center">
          <div class="w-1/2 border border-dashed border-gray-300 p-8 text-center" @drop.prevent="handleDrop" @dragover.prevent="handleDragOver">
            <p class="text-gray-500">Solta el archivo aqui</p>
          </div>
        </div>

      </div>
      <!-- Display Imported Data -->
      <div v-if="pedidos.length > 0">
        <table class="table table-striped">
          <thead>
            <tr class="w-full">
              <th>Cuit</th>
              <th>Razon Social</th>
              <th>Direccion</th>
              <th>Condic. venta</th>
              <th>Observacion</th>
              <th>Total Pedido</th>
              <th>Num. Items</th>
              <th></th>
              <th>Mostrar Arts.</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="ped, key in pedidos" :key="key">
              <tr class="border-b">
                <td>{{ ped.cuit }}</td>
                <td>{{ ped.razon }}</td>
                <td>
                  <select v-model="ped.direccion" class="form-select border-blue-300 bg-gray-100 h-8 my-1 mr-1">
                    <option v-for="(dir, d) in ped.direcciones" :key="d" :value="dir.id">{{ dir.direccion }}</option>
                  </select>
                </td>
                <td>
                  <select v-model="ped.condicion" class="form-select w-24 border-blue-300 bg-gray-100 h-8 my-1 ml-1">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="4">4</option>
                  </select>
                </td>
                <td><input class="form-control" v-model="ped.obs" placeholder="Observacion"></td>
                <td>${{ ped.total.toFixed(2) }}</td>
                <td>{{ ped.cantidadTotal }}</td>
                <td></td>
                <td class="cursor-pointer" @click="ped.mostrar = !ped.mostrar"><div :class="{'arrow': ped.mostrar}">&#9650;</div></td>
              </tr>
              <tr v-if="ped.mostrar">
                <td colspan="9">
                  <table class="table table-dark table-striped">
                    <thead>
                      <tr>
                        <th>Cod. Art.</th>
                        <th>Descr. Art.</th>
                        <th>Cantidad</th>
                        <th>Precio</th>
                        <th>Observacion</th>
                        <!-- Add more inner headers if needed -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(p, i) in ped.items" :key="i">
                        <td>{{ p.art }}</td>
                        <td>{{ p.descrip }}</td>
                        <td>{{ p.cantidad }}</td>
                        <td>${{ Number(p.precio).toFixed(2) }}</td>
                        <td>{{ p.obs }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr class="border-t">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <!-- Advertencias de CUITs no encontrados en el ERP -->
      <div v-if="cuitsNoEncontrados.length > 0" class="alert alert-warning mt-2">
        <strong>&#9888; {{ cuitsNoEncontrados.length }} CUIT(s) no encontrados en el sistema — sus pedidos fueron omitidos:</strong>
        <ul class="mb-0 mt-1" style="max-height:120px;overflow-y:auto;">
          <li v-for="c in cuitsNoEncontrados" :key="c">{{ c }}</li>
        </ul>
      </div>

      <!-- Estado de carga del Excel -->
      <div v-if="cargando && pedidos.length === 0" class="text-center my-3">
        <span class="spinner-border spinner-border-sm me-2"></span> Procesando Excel, por favor espere...
      </div>

      <p v-if="error" class="alert alert-warning mt-2 mb-1">&#9888; {{ error }}</p>

      <!-- Errores parciales del backend (pedidos que fallaron) -->
      <div v-if="erroresBackend.length > 0" class="alert alert-danger mt-2">
        <strong>&#10060; {{ erroresBackend.length }} pedido(s) no se procesaron:</strong>
        <ul class="mb-0 mt-1" style="max-height:200px;overflow-y:auto;">
          <li v-for="e in erroresBackend" :key="e">{{ e }}</li>
        </ul>
      </div>

      <div v-if="pedidos.length > 0" class="flex justify-center gap-2 mt-2">
        <button class="btn btn-danger btn-sm" @click="cancelar" :disabled="cargando">Cancelar</button>
        <button class="btn btn-success btn-sm" @click="aceptar" :disabled="cargando">
          <span v-if="cargando"><span class="spinner-border spinner-border-sm me-1"></span><span v-if="jobId">Procesando {{ jobProcesados }}/{{ jobTotal }}...</span><span v-else>Importando...</span></span>
          <span v-else>Aceptar ({{ pedidos.length }} pedido{{ pedidos.length !== 1 ? 's' : '' }})</span>
        </button>
      </div>
    </div>
  </template>
  
  <script>
import pedidosService from '@/services/pedidos.service';
import usuarioService from '@/services/usuario.service';
import * as XLSX from 'xlsx';

const XLSX_MIME_TYPES = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel'
];

  export default {
    data() {
      return {
        importedData: null,
        orders: {},
        cuits: [],
        pedidos: [],
        cargando: false,
        arts: [],
        error: '',
        cuitsNoEncontrados: [],
        erroresBackend: [],
        jobId: null,
        pollInterval: null,
        pollErrors: 0,
        jobTotal: 0,
        jobProcesados: 0
      };
    },
    methods: {
       downloadExcel() {
        pedidosService.getExcelEjemplo()
        .then((res) => {
            // Create a Blob object from the file content
          const blob = new Blob([res.data]);

          // Create a Blob URL for the file
          const url = window.URL.createObjectURL(blob);
          // Open the file in a new browser tab
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'ejemplo.xlsx');
          document.body.appendChild(link);
          link.click();

          // Clean up by revoking the Blob URL
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {console.log(err)})
      },
      async aceptar() {
        if (this.cargando) return;
        this.cargando = true;
        this.error = '';
        this.erroresBackend = [];
        var pedidos = [];

        for (const p of this.pedidos) {
            var ped = {
                cuit: p.cuit,
                iddir: p.direccion,
                condicion: p.condicion,
                obs: p.obs,
                items: []
            };

            if (!ped.iddir) {
                this.error = 'Falta seleccionar la dirección para el CUIT ' + p.cuit;
                this.cargando = false;
                return;
            }

            p.items.forEach((i) => {
                ped.items.push({ cod: i.art, cantidad: i.cantidad, precio: i.precio, obs: i.obs });
            });
            pedidos.push(ped);
        }

        try {
            const res = await pedidosService.importarPedido(pedidos);
            this.jobId = res.data.jobId;
            this.jobTotal = pedidos.length;
            this.startPolling();
            // cargando se mantiene en true — lo controla el polling
        } catch (err) {
            this.cargando = false;
            console.error(err);
            const data = err?.response?.data;
            if (data?.message) {
                const ref = data.errorId ? ` (Ref: ${data.errorId})` : '';
                this.error = data.message + ref;
            } else if (err?.message) {
                this.error = err.message === 'Network Error'
                    ? 'No se pudo conectar con el servidor. Verifique su conexión e intente nuevamente.'
                    : err.message;
            } else {
                this.error = 'Error al iniciar la importación. Intente nuevamente.';
            }
            this.$root.alertSuccess = false;
            this.$root.isAlertVisible = true;
        }
      },
      startPolling() {
        this.pollErrors = 0;
        this.pollInterval = setInterval(async () => {
          try {
            const res = await pedidosService.getJobStatus(this.jobId);
            const job = res.data;
            this.jobProcesados = job.procesados;
            this.pollErrors = 0;
            if (job.status === 'DONE') {
              this.clearPoll();
              if (job.errores && job.errores.length > 0) {
                const savedErrors = [...job.errores];
                const savedMsg = `${job.procesados} pedido(s) procesado(s) correctamente. ${savedErrors.length} con error (ver detalle abajo).`;
                this.cancelar();
                this.erroresBackend = savedErrors;
                this.error = savedMsg;
                this.$root.alertSuccess = false;
                this.$root.isAlertVisible = true;
              } else {
                this.$root.alertSuccess = true;
                this.$root.isAlertVisible = true;
                this.cancelar();
              }
            }
          } catch (err) {
            if (err?.response?.status === 404) {
              this.clearPoll();
              this.error = 'No se encontró el trabajo de importación en el servidor.';
              this.$root.alertSuccess = false;
              this.$root.isAlertVisible = true;
            } else {
              this.pollErrors++;
              if (this.pollErrors >= 10) {
                this.clearPoll();
                this.error = 'No se pudo obtener el estado de la importación tras varios intentos. Verifique su conexión.';
                this.$root.alertSuccess = false;
                this.$root.isAlertVisible = true;
              }
            }
          }
        }, 1000);
      },
      clearPoll() {
        if (this.pollInterval) {
          clearInterval(this.pollInterval);
          this.pollInterval = null;
        }
        this.cargando = false;
        this.jobId = null;
        this.pollErrors = 0;
        this.jobProcesados = 0;
        this.jobTotal = 0;
      },
      cancelar() {
        this.clearPoll();
        this.cargando = false;
        this.importedData = null;
        this.orders = {};
        this.cuits = [];
        this.pedidos = [];
        this.error = '';
        this.cuitsNoEncontrados = [];
        this.erroresBackend = [];
      },
      async cargarDatosPedido() {
        for (const c of this.cuits) {
          await this.eachUser(c);
        }
      },
      async eachUser(c) {
        await usuarioService.getClienteErpCuit(c)
          .then(async (res) => {
            if (res.data && res.data.id) {
              Object.keys(this.orders[c]).forEach(key => {
                var pedido = {
                  cuit: this.orders[c][key][0].cuit,
                  razon: res.data.razon,
                  num: this.orders[c][key][0].num,
                  obs: '',
                  mostrar: true,
                  total: 0,
                  cantidadTotal: 0,
                  condicion: 1,
                  direcciones: [],
                  direccion: null,
                  items: []
                }
                this.orders[c][key].forEach(x => {
                  if (x.num == key && c == x.cuit) {
                    pedido.total += Number(x.precio * x.cantidad)
                    pedido.cantidadTotal += Number(x.cantidad)
                    pedido.items.push(x)
                  }
                })
                this.pedidos.push(pedido)
              });
              await usuarioService.buscadorDireccionesClienteIdcli(res.data.idcli)
                .then((ans) => {
                  this.pedidos.forEach(e => {
                    if (e.cuit == c) {
                      e.direcciones = ans.data
                      e.direccion = null
                    }
                  })
                })
            } else {
              // CUIT no encontrado en el ERP — avisar al usuario
              this.cuitsNoEncontrados.push(c)
            }
          })
          .catch((err) => {
            // 404 es respuesta esperada cuando no existe el CUIT
            if (err?.response?.status === 404) {
              this.cuitsNoEncontrados.push(c)
            } else {
              console.error('Error buscando CUIT ' + c, err)
              this.cuitsNoEncontrados.push(c)
            }
          })
      },
      isValidExcelFile(file) {
        const name = file.name || '';
        const ext = name.split('.').pop().toLowerCase();
        return ext === 'xlsx' || ext === 'xls' || XLSX_MIME_TYPES.includes(file.type);
      },
      handleFileChange(event) {
        const file = event.target.files[0];
        if (!file) return;
        if (!this.isValidExcelFile(file)) {
          this.error = 'El archivo debe ser un Excel (.xlsx o .xls)';
          // Limpiar el input para permitir volver a seleccionar
          this.$refs.fileInputRef.value = '';
          return;
        }
        this.error = '';
        this.readExcel(file);
      },
      readExcel(file) {
        this.orders = {};
        this.cuits = [];
        this.pedidos = [];
        this.arts = [];
        this.erroresBackend = [];
        this.cuitsNoEncontrados = [];
        this.cargando = true;
        this.error = '';
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          let jsonData;
          try {
            const workbook = XLSX.read(data, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            jsonData.shift(); // quitar encabezado
            this.importedData = jsonData;
          } catch {
            this.error = 'No se pudo leer el archivo Excel. Verifique que no esté dañado.';
            this.cargando = false;
            this.cancelar();
            return;
          }

          // Filtrar filas vacías o incompletas (necesitan al menos cuit, num, art, cantidad)
          const filasValidas = this.importedData.filter(x => {
            return x[0] != null && x[1] != null && x[2] != null && x[3] != null;
          });
          const filasInvalidas = this.importedData.length - filasValidas.length;

          filasValidas.forEach(x => {
            const cuit = x[0];
            const num = x[1];
            if (!this.orders[cuit]) {
              this.orders[cuit] = {};
              this.cuits.push(cuit);
            }
            if (!this.orders[cuit][num]) {
              this.orders[cuit][num] = [];
            }
            var renglon = {
              cuit: cuit,
              num: num,
              art: x[2],
              cantidad: x[3],
              precio: (x[4] != null && !isNaN(x[4])) ? x[4] : 0,
              obs: x[5] || ''
            }
            this.orders[cuit][num].push(renglon);
          });

          if (filasInvalidas > 0) {
            this.error = `Se omitieron ${filasInvalidas} fila(s) con datos incompletos.`;
          }

          if (this.cuits.length === 0) {
            this.error = 'El archivo no contiene datos válidos.';
            this.cargando = false;
            return;
          }

          this.cargarDatosPedido()
            .then(() => {
              this.pedidos.sort((a, b) => a.num - b.num);
              const promises = this.pedidos.map((e, iteracion) => {
                const idarts = [...new Set(e.items.map(i => i.art))];
                return this.loadArtsBatch(idarts, iteracion);
              });
              return Promise.all(promises);
            })
            .catch((err) => {
              console.error('Error cargando datos del pedido', err);
              this.error = 'Error al consultar los datos de los pedidos. Intente nuevamente.';
            })
            .finally(() => {
              this.cargando = false;
            });
        };
        reader.onerror = () => {
          this.error = 'No se pudo leer el archivo.';
          this.cargando = false;
        };
        reader.readAsBinaryString(file);
      },
      loadArtsBatch(list, index) {
        return pedidosService.getProductoCodigoBatch(list)
          .then((ans) => {
            // Reemplazar con filter para no mutar mientras se itera (bug splice/forEach)
            this.pedidos[index].items = this.pedidos[index].items.filter(e => {
              const art = ans.data.find(i => i.codigo_art == e.art);
              if (art) {
                e.descrip = art.descrip_art;
                e.alias = art.alias_art;
                return true;
              }
              return false;
            });
            this.arts.push(...ans.data);
          })
          .catch((err) => {
            console.error('Error cargando artículos para pedido ' + index, err);
          });
      },
      handleDrop(event) {
        const file = event.dataTransfer.files[0];
        if (!file) return;
        if (!this.isValidExcelFile(file)) {
          this.error = 'El archivo debe ser un Excel (.xlsx o .xls)';
          return;
        }
        this.error = '';
        this.readExcel(file);
      },
      handleDragOver(event) {
        event.dataTransfer.dropEffect = 'copy';
      },
    },
    computed: {
    },
  };
  </script>

<style>
.arrow {
  transform: rotate(180deg);
}
</style>
